import React from 'react';
import { AE_CONTAINER, AE_INNER, AE_PAGE } from './aeTheme';

interface AePageShellProps {
  children: React.ReactNode;
}

/**
 * Standard authenticated Assessment Engine page wrapper.
 * Uses full container width — same pattern as RiskManagementPage and other TMOS modules.
 */
export const AePageShell: React.FC<AePageShellProps> = ({ children }) => (
  <div className={AE_PAGE}>
    <div className={`${AE_CONTAINER} ${AE_INNER}`}>{children}</div>
  </div>
);
